import { render, staticRenderFns } from "./BodyFluidParam.vue?vue&type=template&id=1fde182c"
import script from "./BodyFluidParam.vue?vue&type=script&lang=js"
export * from "./BodyFluidParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports